import { render, staticRenderFns } from "./EnterTerminationOtherTenancies.vue?vue&type=template&id=51a48b20&scoped=true"
import script from "./EnterTerminationOtherTenancies.vue?vue&type=script&lang=js"
export * from "./EnterTerminationOtherTenancies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a48b20",
  null
  
)

export default component.exports